export default function detectDeviceType(
    ua: string
): "mobile" | "tablet" | "desktop" {
    const agent = ua.toLowerCase();    
    
    if (/mobile|iphone|ipod|android.*mobile|windows phone/.test(agent))
        return "mobile";
    if (/ipad|tablet|android(?!.*mobile)/.test(agent)) return "tablet";
    return "desktop";
}
